import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { createValidateSingle, maxInputTextLength } from '../../validation';
import { InputField } from '../reduxFields';

const fieldProps = {
    name: 'telephone',
    label: <LocalizedText textKey={TextKey.Phone} />,
    validate: createValidateSingle({
        length: maxInputTextLength,
    }),
};

const TelephoneInputField = () => <InputField {...fieldProps} />;

export default TelephoneInputField;
